var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "parent",
      staticStyle: { height: "calc(100vh - 50px)", width: "100%" }
    },
    [
      _c("comments", {
        attrs: { joborderid: _vm.comment_joborderid, show: _vm.show_comments },
        on: { cancel: _vm.cancel_comment, save: _vm.save_comment }
      }),
      _vm._v(" "),
      _c("dialogue", {
        attrs: {
          title: _vm.dialogTitle,
          paragraph: "",
          button_names: _vm.dialogButtons,
          show: _vm.dialogShow,
          autocompleteId: _vm.autocompleteId
        },
        on: { dialogue: _vm.dialogCall, cancel: _vm.dialogCancel }
      }),
      _vm._v(" "),
      _vm.default_vesselpic != ""
        ? _c(
            "div",
            { staticStyle: { display: "inline" } },
            [
              _c("layout-3", {
                staticStyle: { float: "left", width: "70%" },
                attrs: { id: _vm.pageid1, term: _vm.term, width: 4, height: 2 }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    float: "right",
                    width: "25%",
                    height: "300px",
                    margin: "10px"
                  }
                },
                [
                  _c("vesselpic", {
                    staticStyle: { height: "300px" },
                    attrs: {
                      dir:
                        "vesselpics/vesselpic_" +
                        parseInt(_vm.default_vesselpic) +
                        ".jpg",
                      vesselpic_id: _vm.default_vesselpic
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _c(
            "div",
            [
              _c("layout-3", {
                attrs: { id: _vm.pageid1, term: _vm.term, width: 4, height: 2 }
              })
            ],
            1
          ),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "margin-left": "25px", "margin-right": "25px" }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "overflow-y": "auto", "margin-bottom": "50px" } },
        [
          _vm.parent == true
            ? _c("layout-1", {
                key: _vm.ponumberKey,
                attrs: {
                  table_name: "Parent Job Order",
                  id: _vm.pageid12,
                  searchbar: false,
                  collapseable: true,
                  height_limit: false,
                  navbar: false,
                  select_reroute: true,
                  term: _vm.term
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("5")
            ? _c("layout-1", {
                attrs: {
                  table_name: "Job Schedules",
                  id: _vm.pageid2,
                  searchbar: false,
                  collapseable: true,
                  height_limit: false,
                  navbar: false,
                  select_reroute: true,
                  button_perm: "8",
                  button_name: "Select",
                  term: _vm.term
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("118")
            ? _c("layout-1", {
                key: _vm.commentsKey,
                attrs: {
                  table_name: "Comments",
                  id: _vm.pageid14,
                  searchbar: false,
                  collapseable: true,
                  height_limit: false,
                  navbar: false,
                  select_reroute: true,
                  term: _vm.term
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("6")
            ? _c("layout-1", {
                attrs: {
                  table_name: "Documents",
                  id: _vm.pageid3,
                  searchbar: false,
                  collapseable: true,
                  height_limit: false,
                  navbar: false,
                  select_reroute: true,
                  button_perm: "7",
                  button_name: "Select",
                  term: _vm.term
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("7")
            ? _c("layout-1", {
                attrs: {
                  table_name: "TSheets",
                  id: _vm.pageid4,
                  searchbar: false,
                  collapseable: true,
                  height_limit: false,
                  navbar: false,
                  term: _vm.term
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("73")
            ? _c("layout-1", {
                attrs: {
                  table_name: "Invoices",
                  id: _vm.pageid5,
                  searchbar: false,
                  collapseable: true,
                  height_limit: false,
                  navbar: false,
                  select_reroute: true,
                  button_perm: "73",
                  button_name: "Select",
                  term: _vm.term
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("36")
            ? _c("layout-1", {
                attrs: {
                  table_name: "Activities",
                  id: _vm.pageid6,
                  searchbar: false,
                  collapseable: true,
                  height_limit: false,
                  navbar: false,
                  term: _vm.term
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("38")
            ? _c("layout-1", {
                attrs: {
                  table_name: "Report Times",
                  id: _vm.pageid7,
                  searchbar: false,
                  collapseable: true,
                  height_limit: false,
                  navbar: false,
                  select_reroute: true,
                  button_perm: "38",
                  button_name: "Select",
                  term: _vm.term
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("60")
            ? _c("layout-1", {
                attrs: {
                  table_name: "Subcontractor Hours",
                  id: _vm.pageid8,
                  searchbar: false,
                  collapseable: true,
                  height_limit: false,
                  navbar: false,
                  select_reroute: true,
                  button_perm: "60",
                  button_name: "Edit",
                  term: _vm.term
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("70")
            ? _c("layout-1", {
                key: _vm.ponumberKey,
                attrs: {
                  table_name: "PO Numbers",
                  id: _vm.pageid9,
                  searchbar: false,
                  collapseable: true,
                  height_limit: false,
                  navbar: false,
                  select_reroute: true,
                  button_perm: "71",
                  button_name: "Select",
                  term: _vm.term
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("88")
            ? _c("layout-1", {
                attrs: {
                  table_name: "Inventory Items",
                  id: _vm.pageid11,
                  searchbar: false,
                  collapseable: true,
                  height_limit: false,
                  navbar: false,
                  select_reroute: true,
                  button_perm: "88",
                  button_name: "Select",
                  term: _vm.term
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("122")
            ? _c("layout-1", {
                attrs: {
                  table_name: "WeChat Linking",
                  id: _vm.pageid15,
                  searchbar: false,
                  collapseable: true,
                  height_limit: false,
                  navbar: false,
                  term: _vm.term
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("140")
            ? _c("layout-1", {
                attrs: {
                  table_name: "Joborder Change Log",
                  id: _vm.pageid16,
                  searchbar: false,
                  collapseable: true,
                  height_limit: false,
                  navbar: false,
                  term: _vm.term
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "nav-bar" }, [
        _c("div", [
          _vm.perms.includes("15")
            ? _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.button("Edit")
                    }
                  }
                },
                [_vm._v("Edit Job Order")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("60")
            ? _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.button("Add_Subcontractor")
                    }
                  }
                },
                [_vm._v("Add Subcontractor Hours")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("2")
            ? _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.button("Pictures")
                    }
                  }
                },
                [_vm._v("View Pictures")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("67")
            ? _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.button("Files")
                    }
                  }
                },
                [_vm._v("View Files")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("76")
            ? _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.createFinalReport()
                    }
                  }
                },
                [_vm._v("Prepare Final Report")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("104") && _vm.parent == true
            ? _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.removeParent()
                    }
                  }
                },
                [_vm._v("Remove Parent Job Order")]
              )
            : _vm.perms.includes("104") && _vm.parent == false
            ? _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.addParent()
                    }
                  }
                },
                [_vm._v("Set Parent Job Order")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("104")
            ? _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.addPoNumber()
                    }
                  }
                },
                [_vm._v("Add PO Number")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("38")
            ? _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.createInvoice()
                    }
                  }
                },
                [_vm._v("Create Invoice")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.perms.includes("118")
            ? _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.add_comment()
                    }
                  }
                },
                [_vm._v("Add Comment")]
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c8742e72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8742e72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/View_Job_Orders.vue
// module id = 533
// module chunks = 0